var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLTabs",
    {
      staticClass: "green-fitout green-fitout-sub-tabs shadowline-theme",
      on: { change: _vm.tabPaneChange },
    },
    [
      _vm.shouldShowForTenant || _vm.isHKlandUser
        ? _c(
            "a-tab-pane",
            { key: "1", attrs: { tab: _vm.$t("tenantProjects.comments") } },
            [_c("GreenFitOutComments", { staticClass: "green-fitout__body" })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-tab-pane",
        { key: "2", attrs: { tab: _vm.$t("tenantProjects.guideline") } },
        [
          _c("PostFitOutGuideline", {
            staticClass: "green-fitout__body guidelines",
            attrs: { guidelines: _vm.publishedGuideLines },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }